import React, { useMemo } from "react";
import { DashboardStats } from "./DashboardStats";
import { DashboardFilters } from "./DashboardFilters";
import { KanbanView, ListView, CalendarView } from "./TaskViews";

export const DashboardView = ({
  tasks, filteredTasks,
  filters, setFilters, searchTerm, setSearchTerm,
  viewMode, setViewMode, selectedDate, setSelectedDate,
  sites, studies, users, taskCardProps,
}) => {
  const tasksByStatus = useMemo(() => {
    const grouped = { todo: [], in_progress: [], delayed: [], completed: [] };
    for (const t of filteredTasks) {
      if (grouped[t.status]) grouped[t.status].push(t);
    }
    return grouped;
  }, [filteredTasks]);

  return (
    <div data-testid="dashboard-view" className="space-y-6">
      <DashboardStats tasks={tasks} />
      <DashboardFilters
        filters={filters}
        setFilters={setFilters}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        viewMode={viewMode}
        setViewMode={setViewMode}
        sites={sites}
        studies={studies}
        users={users}
      />
      {viewMode === "kanban" && <KanbanView tasksByStatus={tasksByStatus} taskCardProps={taskCardProps} />}
      {viewMode === "list" && <ListView tasks={filteredTasks} taskCardProps={taskCardProps} />}
      {viewMode === "calendar" && (
        <CalendarView
          tasks={filteredTasks}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
          taskCardProps={taskCardProps}
        />
      )}
    </div>
  );
};
